import { put, call, select } from 'redux-saga/effects'
import * as actions from '../action_creators'
import {
    getHorizon,
    getTeamDashboardId,
    getProfile,
} from '../selectors'
import {
    requiresFetch,
    calculateHorizon,
} from '../../util/horizon_utils'
import { spanWidthDays } from '../../util/date_utils'
import { fetchGoalsForRange } from './goal_sagas'
import { handleFetchTimeEntries, handleFetchRunningTimeEntries } from './time_entries_sagas'

export function* handleRangeChange({ range }) {
    const horizon = yield select(getHorizon, 'viewport')
    const shouldFetch = requiresFetch(range, horizon)
    if (shouldFetch) {
        const width = spanWidthDays(range)
        const newHorizon = calculateHorizon(range, width < 14 ? 20 : 1)
        yield put(actions.setDashboardHorizon(newHorizon))
    }
    
    yield call(fetchGoalsForRange, {range})
}

export function* fetchCurrentHorizon() {
    const { start, end } = yield select(getHorizon, 'viewport')
    const teamId = yield select(getTeamDashboardId)
    yield call(handleFetchTimeEntries, { params: { start, end, teamId } })
    yield call(handleFetchRunningTimeEntries, { params: { teamId } } )
}

export function* handleHorizonChange({ horizon }) {
    const teamId = yield select(getTeamDashboardId)
    yield call(handleFetchTimeEntries, { params: { ...horizon, teamId }  } )
    yield call(handleFetchRunningTimeEntries, { params: { teamId } } )
}

export function* selectTeamDashboardId({ teamId }) {
    const profile = yield select(getProfile)
    const personalTeamId = profile.personalTeamId
    const isPersonalDashboard = personalTeamId === teamId
    const display = isPersonalDashboard
        ? 'list' 
        : 'member'

    const viewerTeamMembership = profile && profile.memberships[teamId]
    const isTeamAdmin = !!viewerTeamMembership && viewerTeamMembership.accessLevel === 'Admin'

    yield put(actions.setDashboardDisplay(display))
    yield put(actions.setDashboardCollapse(!isPersonalDashboard && isTeamAdmin))
    yield put(actions.receiveTeamDashboard(teamId))
}


// WEBPACK FOOTER //
// ./src/redux/sagas/viewport_sagas.js